/* =============================================================================
   CR-FormSummaryStock — FS-088 tooltip ของปุ่มวงกลม (.fss-act) ทั้งโมดูล

   เดิมใช้ title ของ browser ล้วน ๆ ซึ่ง "บางครั้งไม่ขึ้น" (QA แจ้ง 14/10/2026):
     ต้องวางเมาส์นิ่ง ~1 วินาที · ขึ้นแล้วหายเอง · ไม่ขึ้นซ้ำจนกว่าเอาเมาส์ออก-เข้าใหม่ · หลังคลิกไม่ขึ้น
   เปลี่ยนเป็น tooltip ของ Bootstrap 4 (โหลดอยู่แล้วทั้งระบบผ่าน Metronic vendors.bundle.js)
   ขึ้นทันทีที่ hover และหน้าตาเหมือนกันทุก browser

   ── ทำไมผูกแบบ delegate ที่ body ครั้งเดียว ───────────────────────────────────
   ปุ่มถูกวาดใหม่ตลอด (DataTables วาดแถวใหม่ทุกครั้งที่ค้นหา · v-if ใน popup)
   ผูกรายปุ่มต้องตามผูก/ถอดทุกครั้ง พลาดเมื่อไรก็ได้ tooltip ค้าง
   option `selector` ของ Bootstrap สร้าง tooltip ให้ปุ่มตอน hover ครั้งแรกเอง ปุ่มใหม่จึงได้ด้วยเสมอ

   ── title ยังอยู่บนปุ่ม ─────────────────────────────────────────────────────
   Bootstrap ปกติย้าย title ไป data-original-title ถาวร (กัน tooltip ของ browser ซ้อน)
   ที่นี่ย้ายเฉพาะตอนแสดง แล้วคืนตอนซ่อน เพราะ
     • Vue เขียน :title ใหม่เมื่อข้อความเปลี่ยน (เช่นปุ่มลบในแถบลายเซ็นสลับตามสถานะ)
       ถ้าย้ายถาวร Bootstrap จะแสดงข้อความเก่าค้าง
     • เทสและโค้ดเดิมอ่าน title ของปุ่มอยู่หลายจุด
   ============================================================================= */

let installed = false;
let retryTimer = null;
let retries = 0;

export function installFssTooltips() {
  if (installed) return;

  // App.vue ตั้ง window.jQuery เป็นตัวใน bundle (ไม่มี plugin ของ Bootstrap) ก่อน
  // แล้วค่อยโหลด vendors.bundle.js ของ Metronic แบบ async ซึ่งแทน window.jQuery ด้วยตัวที่มี .tooltip
  // ตอนโมดูลนี้ถูกโหลดจึงอาจยังไม่พร้อม — รอเช็คซ้ำทุก 0.5 วินาที (สูงสุด ~30 วินาที)
  const $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.tooltip) {
    if (!retryTimer && retries < 60) {
      retries++;
      retryTimer = setTimeout(function() {
        retryTimer = null;
        installFssTooltips();
      }, 500);
    }
    return;
  }
  installed = true;

  const BTN = ".fss-act";

  $(document.body).tooltip({
    selector: BTN + "[title], " + BTN + "[data-original-title]",
    container: "body",
    trigger: "hover",
    boundary: "window",
    template:
      '<div class="tooltip fss-tooltip" role="tooltip">' +
      '<div class="arrow"></div><div class="tooltip-inner"></div></div>',
  });

  // ก่อนแสดง: เอาข้อความล่าสุดจาก title (Vue อาจเพิ่งเปลี่ยน) แล้วซ่อน title ไม่ให้ tooltip ของ browser ซ้อน
  $(document.body).on("show.bs.tooltip", BTN, function() {
    const title = this.getAttribute("title");
    if (title) {
      this.setAttribute("data-original-title", title);
      this.setAttribute("title", "");
    }
  });

  // ซ่อนแล้ว: คืน title ให้ปุ่มเหมือนเดิม
  $(document.body).on("hidden.bs.tooltip", BTN, function() {
    const original = this.getAttribute("data-original-title");
    if (original && !this.getAttribute("title")) {
      this.setAttribute("title", original);
    }
  });

  // คลิกแล้วปุ่มมักหายไปทันที (ลบแถว · ปิด popup · v-if) ถ้าไม่ปิดก่อน tooltip จะค้างกลางจอ
  $(document).on("mousedown", function() {
    $(BTN).each(function() {
      if ($(this).data("bs.tooltip")) $(this).tooltip("hide");
    });
    $(".fss-tooltip").remove();
  });
}



// WEBPACK FOOTER //
// ./App/Components/PrintSummary/form-summary-stock-tooltips.js